export const isNullish = <T>(input: T): input is T & (null | undefined) => {
  return input === null || input === undefined;
};
